import { appDependencies } from "../wiring/AppDependencies";
import { INotifyResult, IRequestNotify } from "./IRequestNotify";

export class NotifyService implements IRequestNotify {
    notify(messageToDisplay: any): Promise<INotifyResult> {
        return appDependencies.ICanNotify.notify(messageToDisplay);
    }
}
